import React, { Component } from "react";
import { connect } from "react-redux";
import { InputAdornment } from "@mui/material";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { MoneyInput } from "../atoms/MoneyInput";
import ILearn from "../molecules/ILearn";

class IrqPropertyValueView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/property_value_small.svg"
          />
          <div className="money-input-wrapper">
            <MoneyInput
              name="price"
              error={!!this.props.errors.price}
              placeholder="250,000"
              value={this.props.data.price || ""}
              onChange={this.props.onFormEdit}
              onBlur={this.props.onBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    className="date-picker-icon-mobile-wrapper"
                    position="start"
                  >
                    $
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <EditActions canSubmit={this.props.isValid} />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqPropertyValueView));
